import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi there, I'm <span className="purple">Femi</span>
            <br />I am PMP certified Technical Project Manager
            <br />I am a Web and Software Developer with a Bachelor and Masters Degree in Computer Science.
            <br />
            Apart from coding, here are some of my favorite things.
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Bouldering
            </li>
            <li className="about-activity">
              <ImPointRight /> Improv Comedy
            </li>
            <li className="about-activity">
              <ImPointRight /> Songwriting and singing
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Build things that solves problems."{" "}
          </p>
          <footer className="blockquote-footer">Femi</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
